import React, { useEffect, useState } from 'react'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CkeckboxRolesSkeleton from '../../../../skeleton/CkeckboxRolesSkeleton';
import useFetchData from '../../../../../hooks/useFetchData';
import TextEllipsis from '../../../../text/TextEllipsis'
import { Radio, Typography } from '@mui/material';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';

const DialogRoles = ({ show, onClose, onSave, formData = {} }) => {
  const [form, setForm] = useState(formData || {})
  const [errors, setErrors] = useState(null)
  const [radioRoles, setRadioRoles] = useState([])
  const { isLoading, data: dataRoles, error } = useFetchData(`roles`);

  const onChange = (name, checked, isRadio) => {
    let rolesId = []
    
    if (isRadio) {
      if (checked) {
        rolesId = [ name ]
      } else {
        rolesId = []
      }
    } else {
      const role = form?.rolesId?.filter((item) => !radioRoles.includes(item))
      rolesId = new Set(role)

      if (checked) {
        rolesId.add(name)
      } else {
        rolesId.delete(name)
      }
      rolesId = [...rolesId]
    }
    const roles = dataRoles?.filter((role) => rolesId.includes(role.id)) || []
    setForm({ ...form, rolesId: [...rolesId], roles })
  }

  useEffect(() => {
    const roles = dataRoles?.filter((role) => role.id === 'Student' || role.id === 'Parent') || []
    setRadioRoles(roles.map((role) => role.id))
  }, [dataRoles])

  const onApply = () => {
    if (!form?.rolesId || form?.rolesId?.length === 0) {
      setErrors({ message: 'Please select at least one role' })
      return
    }
    onSave(form)
    onClose()
  }


  return (
    <DialogConfirmCancel
      id="user-roles"
      open={show} 
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
      loading={isLoading}
      title='Create new user'
      onCloseHeader={true}
      maxWidth='sm'
    >
      <Typography variant='subtitle1' color='primary'>Roles</Typography>
      <Box className='col-span-3 grid grid-cols-3 gap-1'>
        { error 
          ? <Alert severity='error'>{error.message}</Alert>
          : isLoading
            ? <CkeckboxRolesSkeleton />
            :  dataRoles?.map((role, index) => (
              <div key={`role-${index}-${role._id}`} className='overflow-hidden'>
                <FormControlLabel
                  control={
                    radioRoles.includes(role.id) 
                    ? <Radio
                      id={`radio-roles-${index}-${role._id}`}
                      checked={form?.rolesId?.includes(role.id) ? true : false}
                      name={role._id}
                      onChange={(e) => onChange(role.id, e.target.checked, true)}
                      color='primary'
                    /> 
                    : <Checkbox
                      id={`checkbox-roles-${index}-${role._id}`}
                      checked={form?.rolesId?.includes(role.id) ? true : false}
                      name={role._id}
                      onChange={(e) => onChange(role.id, e.target.checked)}
                      color='primary'
                    />}
                  label={<TextEllipsis id={`text-roles-${index}-${role._id}`}>{role.name}</TextEllipsis>}
                /> 
              </div>
            ))
        }
      </Box>
      { errors?.message && <Alert severity='error'>{errors?.message}</Alert> }
    </DialogConfirmCancel>
  )
}

export default DialogRoles